import { render, staticRenderFns } from "./UserEditContactForm.vue?vue&type=template&id=6112d1a9"
import script from "./UserEditContactForm.vue?vue&type=script&lang=js"
export * from "./UserEditContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports